import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../../Base/Components/BaseModal/BaseModal';
import { Size } from '../../../../../../Enums/Size.enum';
import ManagerInsuranceCompaniesCaseType from './ManagerInsuranceCompaniesCaseType';

interface Props extends BaseModalProps {
	caseTypeId: string;
}

const ManagerInsuranceCompaniesCaseTypeModal = ({
	caseTypeId,
	...modalProps
}: Props) => {
	return (
		<BaseModal
			title={'component.discourse.medicalProcedure'}
			size={Size.LG}
			{...modalProps}>
			<ManagerInsuranceCompaniesCaseType caseTypeId={caseTypeId} />
		</BaseModal>
	);
};

export default ManagerInsuranceCompaniesCaseTypeModal;
